import { createVanIconComponent } from "./van"

const MedalOutlined = createVanIconComponent("medal-o")
export default MedalOutlined
